import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

const PREVIEW_CONTENT_PAGE_ID = "preview-content";

export interface PreviewContentSearch {
  uid?: string;
  cmsTicketId?: string;
}

function buildPath(search: PreviewContentSearch): string {
  const params = new URLSearchParams();
  if (search.uid !== undefined) {
    params.set("uid", search.uid);
  }
  if (search.cmsTicketId !== undefined) {
    params.set("cmsTicketId", search.cmsTicketId);
  }
  const query = params.toString();
  return `/page-data/${PREVIEW_CONTENT_PAGE_ID}${query ? `?${query}` : ""}`;
}

export const previewContentPageQueryOptions = (search: PreviewContentSearch) =>
  queryOptions({
    queryKey: pageDataKeys.pageWithInputs(PREVIEW_CONTENT_PAGE_ID, search),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>(buildPath(search)),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
